<template>
  <v-card tile :style="{ minHeight: !xs ? '650px' : null }" @click.stop="$router.push(`/galleries/cards/${gallery.instance}/${gallery.id}`)">
    <v-img
      v-if="teaserUrl"
      class="white--text align-end"
      style="height: 300px !important"
      cover
      :src="teaserUrl"
      :alt="gallery.name"
      @click="$router.push(`/galleries/cards/${gallery.instance}/${gallery.id}`)"
    >
      <v-card-title class="name-overlay mt-8">
        <p class="ma-0">
          {{ gallery.name }}
        </p>
      </v-card-title>
    </v-img>

    <div
      v-else
      class="d-flex flex-column"
      style="height: 300px; background: #404040"
      @click="$router.push(`/galleries/cards/${gallery.instance}/${gallery.id}`)"
    >
      <div class="d-flex justify-center align-center white--text" style="flex: 1">{{ $t('noTeaser') }}</div>
      <v-card-title class="white--text d-flex">
        <p class="ml-3">
          {{ gallery.name }}
        </p>
      </v-card-title>
    </div>

    <!-- -Updated date and image count in case of gallery marked as unread -->
    <v-card-subtitle v-if="isUnread" class="px-3 pb-0 d-flex flex-column" @click="$router.push(`/galleries/cards/${gallery.instance}/${gallery.id}`)">
      <v-badge v-if="isUnread" right top offset-x="17" offset-y="17" :color="theme.unreadBadgeColor">
        <n-text>
          {{ $t('updated', { date: mx_formatIsoDateStringAsLocaleDateTime(gallery.dateupdated) }) }}
        </n-text>
      </v-badge>
      <n-text v-if="gallery._images">
        {{ $t('gallery.numberOfImages', { imagesCount: gallery._images.length }) }}
      </n-text>
    </v-card-subtitle>

    <!-- -Updated date and image count in case of gallery marked as read -->
    <v-card-subtitle v-else class="px-3 pb-0 flex-column d-flex">
      <n-text>
        <v-icon small :dark="darkMode"> mdi-check</v-icon>
        {{ $t('gallery.viewedAt', { dateAndTime: mx_formatIsoDateStringAsLocaleDateTime(gallery._userState.dateread) }) }}
      </n-text>
      <n-text v-if="gallery._images">
        {{ $t('gallery.numberOfImages', { imagesCount: gallery._images.length }) }}
      </n-text>
    </v-card-subtitle>

    <v-spacer></v-spacer>
    <v-card-text class="px-3">
      <div class="content" :style="contentStyle" v-html="gallery.description"></div>
    </v-card-text>

    <v-card-actions v-if="gallery._images && gallery._images.length > 0" class="px-3">
      <v-btn dark :color="theme.elements.btnColor" @click.stop="$router.push(`/galleries/cards/${gallery.instance}/${gallery.id}`)" class="px-3 mr-3 ml-0">
        {{ $t('gallery.show') }}
      </v-btn>
      <v-btn dark :color="theme.elements.btnColor" @click.stop="$router.push(`/galleries/carousel/${gallery.instance}/${gallery.id}`)" class="px-3 mx-0">
        {{ $t('gallery.showCarousel') }}
      </v-btn>
    </v-card-actions>
    <div v-if="xs" style="padding-bottom: 30px"></div>
  </v-card>
</template>

<script>
import config from '@/common/config';
import commonMixin from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import NText from '@/components/texts/NText';
import index from './index';
import configMixin from '@/mixins/configMixin';

export default {
  name: 'GalleryTeaser',
  props: {
    gallery: Object,
  },
  components: {
    NText,
  },
  mixins: [commonMixin, configMixin, dateTimeMixin],

  computed: {
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, this.$route.params.instance);
    },

    teaser() {
      let gallery = this.gallery;
      if (gallery._teaser) return gallery._teaser;
      // in case no teaser is available, use the first image of the gallery
      return gallery._images && gallery._images.length > 0 ? gallery._images.sort((a, b) => a.sort - b.sort)[0] : null;
    },
    teaserUrl() {
      return this.teaser ? `${config.apiUrl}/medias/${index.api}/${this.teaser.filename}/${this.teaser.checksum}` : null;
    },
    isUnread() {
      return !this.gallery._userState.dateread;
    },

    fixedHeights() {
      return this.moduleConfig.fixedHeights === true;
    },
    contentStyle() {
      if (!this.xs && this.fixedHeights) {
        return 'height:200px';
      }
      return 'padding-bottom:10px';
      // return `max-height:${this.itemContent ? this.itemContent.length * 0.1 : 20}px`;
    },
  },
  methods: {
    displayGallery() {
      this.$router.push(`/galleries/cards/${this.gallery.instance}/${this.gallery.id}`);
      this.$store.dispatch(`sendbox/markAsRead`, { item: this.gallery }, { root: true });
    },
  },
};
</script>
<style scoped>
.content {
  overflow-y: scroll;
  font-size: 1.1rem;
  line-height: 1.5rem;
}

.name-overlay {
  background: #101010;
  color: white;
  opacity: 0.6;
}

.gradient-overlay-dark,
.gradient-overlay-light {
  position: absolute;
  bottom: 65px;
  left: 0;
  right: 0;
  height: 100px;
}

.gradient-overlay-light {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.9));
}

.gradient-overlay-dark {
  background: linear-gradient(to bottom, rgba(31, 31, 31, 0.1), rgba(31, 31, 31, 0.9));
}
</style>
